import React, { useContext, useEffect, useState } from "react"
import { AuthContext } from "../../../hooks/context/authContext";
import { usePostRequest } from "../../../hooks/usePostRequest/usePostRequest";
import { useGetRequest } from "../../../hooks/useGetRequest/useGetRequest";
import GenericModal from "../../../components/modal/GenericModal";
import { FILE_FORMATS, GENERIC_SUCCESS_TOAST_MESSAGE } from "../../../constants/hardCodedConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadSolicitudMiembroMesaAPI, guardarSolicitudMiembroMesaAPI } from "../../../consumers/backendApisUrls";
import { mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState } from "../../../consumers/httpRequiestsUtils";
import { toast } from "react-toastify";
import InputUploadFile from "../../../components/modalComponents/InputUploadFile";
import { downloadFile } from "../../../consumers/backendConsumer";

const FirmaSolicitudMiembroMesaModal = ({ showModal, idEmpleado, idEmpleadoFlujoActividad, manageSearch }) => {
    const { state } = useContext(AuthContext);
    const [executePostRequest] = usePostRequest();
    const [executeGetRequest] = useGetRequest();
    const [validation, setValidation] = useState({});
    const [guardando, setGuardando] = useState(false);
    const [documentoFirmado, setDocumentoFirmado] = useState({});
    const [firmaColaborador, setFirmaColaborador] = useState({});
    const KEYS_INIT = { FirmaFileViewModel: "FirmaFileViewModel" };
    const SECTION_NAME = "modalFirmaSolicitudMiembroMesaModal";
    const [subiendoArchivo, setSubiendoArchivo] = useState(false);
    const [s3UploadFileResponse, setS3UploadFileResponse] = useState({});
    const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;
    const sectionName = "SolicitudMiembroMesa";

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);
    
    // Limpiar el error cuando el usuario sube un archivo
    useEffect(() => {
        if (!isEmptyObject(firmaColaborador)) {
            setValidation(prev => {
                const newValidation = { ...prev };
                delete newValidation["FileViewModel"];
                delete newValidation["viewModel.FileViewModel"];
                return newValidation;
            });
            setDocumentoFirmado({});
        }
    }, [firmaColaborador]);
    const init = async function () {

    };

    const onSubmit = async (e) => {
        e.preventDefault(); 
        if (guardando) return;
           
        // 1. Validar que la imagen de la firma exista
        if (isEmptyObject(firmaColaborador) || !firmaColaborador.OriginalFileName) {
            setValidation({ "FileViewModel": "Debe subir su firma antes de guardar." });
            return;
        }

        setGuardando(true);

        // 2. Asegurar que tenemos el PDF generado
        let pdfParaGuardar = documentoFirmado;

        if (isEmptyObject(pdfParaGuardar)) {
            // Si el usuario NO hizo clic en previsualizar, lo generamos ahora
            pdfParaGuardar = await obtenerFormatoFirmado();
        }

        if (!pdfParaGuardar) {
            mostrarMensajeDeErrorConToast("No se pudo generar el documento con la firma. Intente nuevamente.");
            setGuardando(false);
            return;
        }
        
        let payload = {
            IdEmpleado: idEmpleado,
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: pdfParaGuardar
        };
        setGuardando(true);
        const response = await executePostRequest(guardarSolicitudMiembroMesaAPI(), payload);
        if (responseCode200(response)) {
            showModal();
            toast.success((response?.data?.Message) ? response?.data?.Message : GENERIC_SUCCESS_TOAST_MESSAGE);
            setGuardando(false);
            await manageSearch();
        } else if (responseTieneModelState(response)) {
            setValidation(response?.response?.data.ModelState);
            setGuardando(false);
        } else {
            mostrarMensajeDeErrorConToast(response);
            setGuardando(false);
        }
    };
    
    const btnDownloadFormatoAFirmar = async (event) => {
        event.preventDefault();
        const dataBody = await obtenerFormatoFirmado();
        if (dataBody)
            downloadFile(state.token, dataBody?.Path, dataBody?.OriginalFileName);

    };

    const obtenerFormatoFirmado = async () => {
        const updatedFirmaColaborador = {
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: firmaColaborador
        };
        const response = await executePostRequest(downloadSolicitudMiembroMesaAPI(), updatedFirmaColaborador);
        if (responseCode200(response)) {
            setDocumentoFirmado(response.data.Body);
            return response.data.Body;
        } else {
            mostrarMensajeDeErrorConToast(response);
            setDocumentoFirmado({});
            return null;
        }
    }

    return (
        <>
        <GenericModal showModal={showModal} width={"890px"} titulo="Firmar Solicitud para día libre por ser miembros de mesa">

            <div className="modal-body">
                <form className="blue-standard-color">
                    <div className="form-group row mb-0">
                        <div className="col-sm-4 black-color">
                            <InputUploadFile
                                label=""
                                direction="column"
                                textButton="Subir Firma"
                                name={KEYS_INIT.FirmaFileViewModel}
                                uploadFile={firmaColaborador}
                                setUploadFile={setFirmaColaborador}
                                isUploading={subiendoArchivo}
                                setIsUploading={setSubiendoArchivo}
                                sectionName={SECTION_NAME}
                                showToastSuccess={true}
                                validExtensions={FILE_FORMATS.ALLOWED_IMAGE_FORMATS} />   
                            
                            {validation && (validation["viewModel.FileViewModel"] || validation["FileViewModel"]) && (
                                <p className="ficha-form-input-validation-message text-danger">
                                    {validation["viewModel.FileViewModel"] || validation["FileViewModel"]}
                                </p>
                            )}


                        </div>
                        <label className="col-sm-8 col-form-label text-justify">
                            1. Subir imagen de firma en formato .jpg o .png.
                        </label>
                    </div>
                    <div className="form-group row mb-0">
                        <div className="col-sm-4 black-color">
                            <div className="row custom-form-group-modal">
                                <u>
                                    <a className="text-link-appereance" href="#" onClick={(event) => btnDownloadFormatoAFirmar(event)}><FontAwesomeIcon icon='download' /> Previsualizar Documento</a>                                    
                                </u>
                            </div>
                        </div>
                        <label className="col-sm-8 col-form-label text-justify">
                            2. Previsualiza el documento con tu firma incluída.
                        </label>
                    </div>
                    <div className="form-group row mb-0">
                        <div className="col-sm-4 black-color">
                            &nbsp;
                        </div>
                        <label className="col-sm-8 col-form-label text-justify">
                            3. Clic en "Guardar".
                        </label>
                    </div>

                </form>
            </div>

            <div className="modal-footer" style={{ 'display': 'flex', 'justifyContent': 'space-between' }}>
                <div className="message font-gothan-light" style={{ 'alignSelf': 'flex-start' }}>
                    <strong>
                        <p>* Campos obligatorios</p>
                        <p>* Esta firma servirá para generar la solcitud y se eliminará automáticamente después de aprobarse.</p>                        
                    </strong>
                </div>
                <div className="button" style={{ 'alignSelf': 'flex-end' }}>
                    <button className="btn btn-primary generic-button-ficha" onClick={onSubmit} disabled={subiendoArchivo || guardando}>Guardar</button>
                </div>
            </div>
        </GenericModal>
        </>
    );

}
export default FirmaSolicitudMiembroMesaModal;